import { render, staticRenderFns } from "./AccountChangePassword.vue?vue&type=template&id=1f603ef6&"
import script from "./AccountChangePassword.vue?vue&type=script&lang=ts&"
export * from "./AccountChangePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f603ef6')) {
      api.createRecord('1f603ef6', component.options)
    } else {
      api.reload('1f603ef6', component.options)
    }
    module.hot.accept("./AccountChangePassword.vue?vue&type=template&id=1f603ef6&", function () {
      api.rerender('1f603ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/AccountChangePassword.vue"
export default component.exports